"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { WvcLogo } from "@/integrations/wordpress/WvcLogo";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { Facebook, Instagram, Twitter, MapPin, Phone, Mail, Clock, CreditCard } from "lucide-react";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="flex flex-col gap-3">
        {[1, 2, 3, 4].map((_, i) => <div key={i} data-index={i} className="h-5 w-32 bg-muted/20 animate-pulse rounded-md" />)}
      </div>;
  }
  if (!menuItems || menuItems.length === 0) {
    return <ul className="flex flex-col gap-3">
        {[{
        label: "Inicio",
        href: "/HomePage"
      }, {
        label: "Productos",
        href: "/ShopPage"
      }, {
        label: "Personalización",
        href: "/BulkCustomizationPage"
      }, {
        label: "Sostenibilidad",
        href: "/SustainabilityImpactPage"
      }].map((item, i) => <li key={i} data-index={i}>
            <Link to={item.href} className="text-primary-foreground/80 hover:text-primary-foreground transition-colors duration-200 text-sm font-medium font-mono">
              {item.label}
            </Link>
          </li>)}
      </ul>;
  }
  return <ul className="flex flex-col gap-3">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="text-primary-foreground/80 hover:text-primary-foreground transition-colors duration-200 text-sm font-medium font-mono">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
export default function InformativeFooter() {
  const currentYear = new Date().getFullYear();
  return <section data-section-id="252794" id="ecopack-solutions-footer" className="bg-primary text-primary-foreground pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8 mb-16">
          
          {}
          <div className="flex flex-col gap-6">
            <Link to="/" className="inline-block w-fit">
              <WvcLogo className="h-10 w-auto text-primary-foreground" />
            </Link>
            <p className="text-primary-foreground/90 text-sm leading-relaxed font-default">
              Nuestra misión es proveer soluciones de empaque premium y sostenibles que protegen tanto tus productos como el planeta. Calidad Kraft para marcas conscientes.
            </p>
            <div className="flex items-center gap-4 mt-2">
              <Link to="#" className="bg-primary-foreground/10 p-2 rounded-md text-primary-foreground hover:text-primary hover:bg-primary-foreground transition-all duration-200 shadow-sm">
                <Facebook className="size-5" />
                <span className="sr-only">Facebook</span>
              </Link>
              <Link to="#" className="bg-primary-foreground/10 p-2 rounded-md text-primary-foreground hover:text-primary hover:bg-primary-foreground transition-all duration-200 shadow-sm">
                <Instagram className="size-5" />
                <span className="sr-only">Instagram</span>
              </Link>
              <Link to="#" className="bg-primary-foreground/10 p-2 rounded-md text-primary-foreground hover:text-primary hover:bg-primary-foreground transition-all duration-200 shadow-sm">
                <Twitter className="size-5" />
                <span className="sr-only">Twitter</span>
              </Link>
            </div>
          </div>

          {}
          <div className="flex flex-col gap-6">
            <h3 className="text-lg font-bold font-default text-primary-foreground tracking-tight">Contacto</h3>
            <ul className="flex flex-col gap-4">
              <li>
                <Link to="tel:1234567890" className="flex items-start gap-3 text-primary-foreground/80 hover:text-primary-foreground transition-colors duration-200 group">
                  <Phone className="size-5 shrink-0 mt-0.5 group-hover:text-primary-foreground" />
                  <span className="text-sm font-mono">(+34) 900-PACK-LUX</span>
                </Link>
              </li>
              <li>
                <Link to="mailto:hello@packlux.com" className="flex items-start gap-3 text-primary-foreground/80 hover:text-primary-foreground transition-colors duration-200 group">
                  <Mail className="size-5 shrink-0 mt-0.5 group-hover:text-primary-foreground" />
                  <span className="text-sm font-mono">hello@packlux.com</span>
                </Link>
              </li>
              <li className="flex items-start gap-3 text-primary-foreground/80">
                <MapPin className="size-5 shrink-0 mt-0.5" />
                <span className="text-sm font-default">Polígono Industrial Eco, Nave 42, Madrid, ES</span>
              </li>
              <li className="flex items-start gap-3 text-primary-foreground/80">
                <Clock className="size-5 shrink-0 mt-0.5" />
                <span className="text-sm font-default">Lunes - Viernes: 8am - 6pm</span>
              </li>
            </ul>
          </div>

          {}
          <div className="flex flex-col gap-6">
            <h3 className="text-lg font-bold font-default text-primary-foreground tracking-tight">Navegación</h3>
            <MenuProvider menu_id="23">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>

          {}
          <div className="flex flex-col gap-6">
            <h3 className="text-lg font-bold font-default text-primary-foreground tracking-tight">Legal y Envíos</h3>
            <ul className="flex flex-col gap-3">
              {[{
              label: "Términos de Servicio",
              href: "#"
            }, {
              label: "Privacidad Orgánica",
              href: "#"
            }, {
              label: "Logística Sostenible",
              href: "#"
            }, {
              label: "Garantía de Calidad",
              href: "#"
            }, {
              label: "Centro de Ayuda",
              href: "#"
            }].map((link, i) => <li key={i} data-index={i}>
                  <Link to={link.href} className="text-primary-foreground/80 hover:text-primary-foreground transition-colors duration-200 text-sm font-medium font-mono">
                    {link.label}
                  </Link>
                </li>)}
            </ul>
          </div>

        </div>
      </div>

      {}
      <div className="border-t border-primary-foreground/10 bg-primary/50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-sm text-primary-foreground/60 text-center md:text-left font-mono">
              &copy; {currentYear} PACKLUX. Empaques que respiran naturaleza.
            </p>
            <div className="flex items-center gap-3 text-primary-foreground/60">
              <CreditCard className="size-6 opacity-70 hover:opacity-100 transition-opacity" />
              <div className="h-6 w-10 bg-primary-foreground/10 rounded-md flex items-center justify-center text-[10px] font-bold opacity-70 hover:opacity-100 transition-opacity cursor-default font-mono">VISA</div>
              <div className="h-6 w-10 bg-primary-foreground/10 rounded-md flex items-center justify-center text-[10px] font-bold opacity-70 hover:opacity-100 transition-opacity cursor-default font-mono">AMEX</div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}